import axios from 'axios';

import axiosInstance from '../../lib/axios';
import { presignHeaders } from '../../lib/presign';

// The caller's own card: no id in the path, the token picks the member.
const PROFILE = '/admin/team/profile/';

// Bare object. A member who has never written a profile gets the same shape with
// empty values, never a 404.
export const fetchMyProfile = async () => {
  const response = await axiosInstance.get(PROFILE);
  return response.data;
};

// Full replace: whatever is omitted is reset to its default. Always send the whole card.
export const saveMyProfile = async (payload) => {
  const response = await axiosInstance.put(PROFILE, payload);
  return response.data;
};

// No body: the server stamps the caller's own member, and a repeat keeps the first stamp.
export const completeWalkthrough = async () => {
  const response = await axiosInstance.post(`${PROFILE}walkthrough/`);
  return response.data;
};

// Separate three-step flow; the newest confirmed upload wins. Send only the signed headers
// on the PUT: an extra one breaks the signature.
export const uploadProfilePicture = async (file) => {
  const { data: requested } = await axiosInstance.post('/admin/assets/upload/request/', {
    filename: file.name,
    asset_type: 'team_member_profile',
  });

  const presignedUrl = requested.presignedUrl || requested.presigned_url;
  const assetId = requested.assetId || requested.asset_id;

  await axios.put(presignedUrl, file, { headers: presignHeaders(requested, file.type) });

  // Until this lands the asset stays pending and profile_image_url keeps returning null.
  // It also verifies the object arrived, so a failed upload surfaces here as a 400.
  const { data: confirmed } = await axiosInstance.post('/admin/assets/upload/confirm/', {
    asset_id: assetId,
  });
  return confirmed;
};
